import web3 from "../web3";
import abi from './tenupsmart.json';

const TenupSmart = new web3.web3.eth.Contract(
  abi,
  process.env.REACT_APP_STAKING_TOKEN_ADDRESS
);

export default TenupSmart;